// React
import React from 'react';

// Libs
import { Loader, Table } from 'semantic-ui-react';
import { LoaderState } from '../../../types/LoaderState';

// Type
type LeadsLoadingComponentProps = {
    colSpan: number;
    state: LoaderState;
};

/**
 * Loading inside Table snippet.
 *
 * @returns React.ReactElement
 */
export default function LeadsLoadingComponent(props: LeadsLoadingComponentProps): React.ReactElement {
    return (
        <Table.Body>
            <Table.Row data-testid="LeadsLoading">
                <Table.Cell colSpan={props.colSpan} textAlign="center" selectable={false}>
                    <div style={{ height: '120px' }}>
                        <Loader active>{props.state.message}</Loader>
                    </div>
                </Table.Cell>
            </Table.Row>
        </Table.Body>
    );
}
